import { render, staticRenderFns } from "./SendRedirect.vue?vue&type=template&id=c9c9f79a&"
import script from "./SendRedirect.vue?vue&type=script&lang=js&"
export * from "./SendRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports